import { TRefinanceableDebt } from '@axo/form/feature/axo-form-v1/components/ExtendedLoanOverview/context/ExtendedLoanOverviewContext/ExtendedLoanOverviewContext.types';
import { Debt } from '@axo/shared/data-access/types';

type GetDebtsWithRefinanceAmountParams = {
  debts?: Partial<Debt>[];
  refinanceableDebts: TRefinanceableDebt[];
};

export const getDebtsWithRefinanceAmount = ({
  debts,
  refinanceableDebts,
}: GetDebtsWithRefinanceAmountParams) =>
  debts?.map((debt) => {
    const editedRefinanceableDebt = refinanceableDebts.find(
      (refinanceableDebt) =>
        refinanceableDebt.key === debt.ID ||
        (refinanceableDebt.value === debt.OutstandingAmount &&
          refinanceableDebt.label === debt.Creditor)
    );

    if (!editedRefinanceableDebt) return debt;

    return {
      ...debt,
      RefinanceAmount: editedRefinanceableDebt.isChecked
        ? editedRefinanceableDebt.value
        : 0,
    };
  }) || [];
